(function () {
  var ROOT_SELECTOR = '[data-bbj-product-recommendations]';
  var SPLIDE_SELECTOR = '.babybjorn-product-recommendations__splide';

  function getSplideOptions(mobilePerPage) {
    var rtl = document.documentElement.getAttribute('dir') === 'rtl';
    var padKey = rtl ? 'left' : 'right';
    var peek = {};
    peek[padKey] = '6.25%';
    var peekMd = {};
    peekMd[padKey] = '10%';
    // With a single card on mobile a larger trailing pad is needed so ~20% of
    // the next card peeks (1.2 products visible); two-up keeps the tighter peek.
    var peekSm = {};
    peekSm[padKey] = mobilePerPage === 1 ? '18%' : '14%';

    return {
      type: 'slide',
      direction: rtl ? 'rtl' : 'ltr',
      perPage: 4,
      perMove: 1,
      gap: '1rem',
      padding: peek,
      pagination: false,
      arrows: false,
      drag: true,
      rewind: false,
      speed: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 400,
      breakpoints: {
        989: {
          perPage: 3,
          padding: peekMd,
          gap: '0.85rem',
        },
        749: {
          perPage: mobilePerPage,
          padding: peekSm,
          gap: '0.65rem',
        },
      },
    };
  }

  function syncArrows(splide, prevBtn, nextBtn) {
    if (!splide || !splide.Components || !splide.Components.Controller) return;
    var end = 0;
    try {
      end = splide.Components.Controller.getEnd();
    } catch (e) {
      return;
    }
    var i = splide.index;
    if (prevBtn) {
      prevBtn.disabled = i <= 0;
    }
    if (nextBtn) {
      nextBtn.disabled = i >= end;
    }
  }

  function mountSplide(el) {
    if (!el || el.dataset.bbjSplideReady === '1') return;
    if (typeof Splide === 'undefined') return;

    var root = el.closest(ROOT_SELECTOR);
    var prevBtn = root && root.querySelector('[data-bbj-pr-prev]');
    var nextBtn = root && root.querySelector('[data-bbj-pr-next]');
    var mobilePerPage = Math.min(2, Math.max(1, parseInt(el.dataset.mobilePerPage || '2', 10)));

    var splide = new Splide(el, getSplideOptions(mobilePerPage));
    splide.mount();
    el._babybjornSplide = splide;
    el.dataset.bbjSplideReady = '1';

    function refreshLayout() {
      try {
        splide.refresh();
      } catch (e) {
        /* noop */
      }
    }

    refreshLayout();

    var onPrev = function (e) {
      e.preventDefault();
      splide.go('<');
    };
    var onNext = function (e) {
      e.preventDefault();
      splide.go('>');
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', onPrev);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', onNext);
    }

    var update = function () {
      syncArrows(splide, prevBtn, nextBtn);
    };
    splide.on('mounted moved resized updated', update);
    update();

    el._babybjornSplideCleanup = function () {
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      splide.destroy();
      delete el._babybjornSplide;
      delete el._babybjornSplideCleanup;
      delete el.dataset.bbjSplideReady;
    };
  }

  function destroySplideIn(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(SPLIDE_SELECTOR).forEach(function (el) {
      if (el._babybjornSplideCleanup) {
        el._babybjornSplideCleanup();
      }
    });
  }

  function scheduleMount(root) {
    var target = root || document;
    queueMicrotask(function () {
      if (typeof Splide === 'undefined') {
        requestAnimationFrame(function () {
          if (typeof Splide !== 'undefined') {
            target.querySelectorAll(SPLIDE_SELECTOR).forEach(mountSplide);
          }
        });
        return;
      }
      target.querySelectorAll(SPLIDE_SELECTOR).forEach(mountSplide);
    });
  }

  function watchRecommendations(root) {
    var host = root.querySelector('product-recommendations');
    if (!host || host.dataset.bbjRecommendationsWatch === '1') return;
    host.dataset.bbjRecommendationsWatch = '1';

    // <product-recommendations> fetches and swaps its innerHTML exactly once
    // when it scrolls into view. We only need to re-mount Splide for that single
    // swap — staying subscribed would let later subtree mutations (or the swap
    // landing mid-swipe) destroy & re-mount the slider, snapping it back to the
    // first slide. So disconnect after the first mutation.
    var observer = new MutationObserver(function () {
      observer.disconnect();
      destroySplideIn(root);
      scheduleMount(root);
    });

    observer.observe(host, { childList: true });
    host._bbjRecommendationsObserver = observer;
  }

  function initRoot(root) {
    if (!root || root.dataset.bbjRecommendationsBound === '1') return;
    root.dataset.bbjRecommendationsBound = '1';
    watchRecommendations(root);
    scheduleMount(root);
  }

  document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector(ROOT_SELECTOR);
    if (root) {
      var host = root.querySelector('product-recommendations');
      if (host && host._bbjRecommendationsObserver) {
        host._bbjRecommendationsObserver.disconnect();
      }
      destroySplideIn(root);
    }
  });
})();
